import { DURATIONS } from "../constants";

interface FilterBarProps {
  activeDuration: number;
  minPrice: string;
  maxPrice: string;
  onDurationChange: (index: number) => void;
  onMinPriceChange: (val: string) => void;
  onMaxPriceChange: (val: string) => void;
}

export default function FilterBar({
  activeDuration,
  minPrice,
  maxPrice,
  onDurationChange,
  onMinPriceChange,
  onMaxPriceChange,
}: FilterBarProps) {
  return (
    <div className="flex items-center gap-2 px-4 pt-2 pb-3 overflow-x-auto" style={{ scrollbarWidth: "none" }}>
      {/* Duration filter */}
      <div className="flex gap-1.5 flex-shrink-0">
        {DURATIONS.map((d, i) => (
          <button
            key={d}
            onClick={() => onDurationChange(i)}
            className="px-2.5 py-1 rounded-lg text-xs cursor-pointer whitespace-nowrap transition-all"
            style={{
              background: activeDuration === i ? "#EFF6FF" : "#F9FAFB",
              color: activeDuration === i ? "#1E3A8A" : "#9CA3AF",
              border: activeDuration === i ? "1px solid #BFDBFE" : "1px solid #F3F4F6",
            }}
          >
            {d}
          </button>
        ))}
      </div>

      <div className="w-px h-4 flex-shrink-0" style={{ background: "#E5E7EB" }} />

      {/* Price range */}
      <div className="flex items-center gap-1 flex-shrink-0">
        <input
          type="number"
          value={minPrice}
          onChange={(e) => onMinPriceChange(e.target.value)}
          placeholder="最低价"
          className="w-16 px-2 py-1 rounded-lg text-xs outline-none"
          style={{ background: "#F9FAFB", border: "1px solid #F3F4F6", color: "#374151" }}
        />
        <span className="text-xs text-gray-400">-</span>
        <input
          type="number"
          value={maxPrice}
          onChange={(e) => onMaxPriceChange(e.target.value)}
          placeholder="最高价"
          className="w-16 px-2 py-1 rounded-lg text-xs outline-none"
          style={{ background: "#F9FAFB", border: "1px solid #F3F4F6", color: "#374151" }}
        />
      </div>
    </div>
  );
}
